import { render, staticRenderFns } from "./SkinPriceChip.vue?vue&type=template&id=736568e2&scoped=true&"
import script from "./SkinPriceChip.vue?vue&type=script&lang=ts&"
export * from "./SkinPriceChip.vue?vue&type=script&lang=ts&"
import style0 from "./SkinPriceChip.vue?vue&type=style&index=0&id=736568e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736568e2",
  null
  
)

export default component.exports